import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { backendURL } from 'config';

/**
 * Bounces `/auth/:provider` on the frontend to the backend's
 * `/auth/:provider` endpoint, which then redirects to the provider's
 * consent screen. Lives as a real route so users who land on the URL
 * (sign-in button, bookmark, deep link) don't see the 404 page while
 * the OAuth roundtrip is starting.
 */
export default function OAuthStart() {
  const { provider } = useParams();
  useEffect(() => {
    const safe = /^[a-z]+$/.test(provider || '') ? provider : null;
    if (safe) {
      window.location.replace(`${backendURL}/auth/${safe}`);
    } else {
      window.location.replace('/');
    }
  }, [provider]);
  return null;
}
